import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

export const PENDING_ACCESS_REQUESTS_COUNT_KEY = ['access-requests-manageable-pending-count']

// Pending (status=pending only) access request count for resources the current
// user administers — powers the sidebar "Access requests" badge and the
// "Requests for my resources" tab badge. Mirrors usePendingProposalsCounts'
// polling shape (see /scope/proposals/pending-counts).
export function usePendingAccessRequestsCount() {
  return useQuery({
    queryKey: PENDING_ACCESS_REQUESTS_COUNT_KEY,
    queryFn: () =>
      api.get<{ count: number }>('/access-requests/manageable-pending-count').then(r => r.data.count),
    refetchInterval: 30_000,
    staleTime: 15_000,
  })
}
